var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrowDown = function SvgArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 29,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.315 0c.85 0 1.698.378 2.346 1.136L21 19.094 36.34 1.136c1.295-1.514 3.395-1.514 4.69 0 1.293 1.516 1.293 3.974 0 5.49L23.345 27.328c-1.295 1.514-3.395 1.514-4.69 0L.97 6.627C-.323 5.11-.323 2.652.97 1.136 1.618.378 2.466 0 3.315 0Z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowDown;